import {FormDrawer} from './FormDrawer';
import {DrawerProps} from '@mantine/core';
import {useBankAccount} from '../hooks/useBankAccount';
import {BankAccount} from '../types';
import {useParams} from 'react-router-dom';

export const AddFormDrawer = (props: DrawerProps) => {

    const {id: customerId} = useParams();

    if (typeof customerId === 'undefined') {
        throw new Error('customerId is required parameter');
    }

    const {createRecord} = useBankAccount(customerId);

    return (
        <FormDrawer
            record={{
                id: '',
                customerId: customerId,
                currency: 'usd',
                country: 'US',
            } as BankAccount}
            handleSubmit={createRecord}
            {...props}
        />
    );
};
